import React from "react";
import styles from "./styles/PlasticMouldingHero.module.css";
import heroBg from "../../../images/PlasticMoulding.jpg";

export default function PlasticMouldingHero() {
  return (
    <section className={styles.hero} style={{ backgroundImage: `url(${heroBg})` }}>
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>Plastic Moulding</h1>
          <p className={styles.description}>making your product idea a reality</p>
        </div>
      </div>
    </section>
  );
}
